export default __webpack_public_path__ + "images/register.5094b0fb.svg";